module.exports = __webpack_public_path__ + "img/ivan.0dee9652.jpg";